module.exports = __webpack_public_path__ + "static/media/pg-contato.7308106a.png";